/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

interface DividerProps {
  vertical?: boolean;
  style?: React.CSSProperties;
}

const Divider = (props: DividerProps) => {
  const { vertical = false, style = {} } = props;

  if (vertical) {
    return (
      <div
        style={{
          border: '1px solid #eaecf0',
          marginTop: '-1em',
          width: 1,
          ...style,
        }}
      />
    );
  }

  return (
    <div
      style={{
        border: '1px solid #eaecf0',
        width: '100%',
        margin: '1em 0',
        ...style,
      }}
    />
  );
};

export default Divider;
